import React from 'react';
import './Equipped.css';

const Equipped = () => {
  return (
    <div className="equipped-container">
      <h2 className="equipped-heading">FEATURES</h2>

      <div className="equipped-card"data-aos="fade-down" >
        <p className="equipped-description">
          The injection molding machine injects the first material into the mould and the plastic takes the shape.
          After the mould is open, the movable rotary mould platen turns around with the other work pieces by 180°,
          then the machine makes the second injection after the injection nozzles is directed at the cavities of the
          mould and the mould is closed, and then finally takes shape; Or the first material injection and the second
          material can be done at the same time to take shape.
        </p>

        <ul className="equipped-list">
          <li><strong>Rotary Mold Design –</strong> Equipped with rotary mold platen, which is suitable for producing the double color product.</li>
          <li><strong>Mechanical Positioning –</strong> Positioning with mechanism for more precise and stable.</li>
          <li><strong>External Hydraulic and Water Cooling System –</strong> Easier for operation and maintenance.</li>
          <li><strong>Servo Hydraulic System –</strong> Saving more energy and higher precision.</li>
          <li><strong>Shorten Molding Time –</strong> Two independent controls for the shot platforms to achieved injection simultaneously.</li>
        </ul>
      </div>
    </div>
  );
};

export default Equipped;
